export const listOfTeams = {
  "Georgia": 61,
  "Michigan": 130,
  "Ohio State": 194,
  "Alabama": 333,
  "LSU": 99,
  "Penn State": 213,
  "Florida State": 52,
  "USC": 30,
  "Washington": 264,
  "Texas": 251,
  "Tennessee": 2633,
  "Clemson": 228,
  "Notre Dame": 87,
  "Oregon": 2483,
  "Utah": 254,
  "Kansas State": 2306,
  "Oklahoma": 201,
  "North Carolina": 153,
  "Ole Miss": 145,
  "Wisconsin": 275,
  "TCU": 2628,
  "Texas A&M": 245,
  "Missouri": 142,
  "Iowa": 2294,
  "UCLA": 26,
  "Oklahoma State": 197,
  "Tulane": 2655,
  "Kentucky": 96,
  "South Carolina": 2579,
  "Arkansas": 8,
  "Auburn": 2,
  "Mississippi State": 344,
  "Minnesota": 135,
  "Texas Tech": 2641,
  "Purdue": 2509,
  "Maryland": 120,
  "Illinois": 356,
  "Baylor": 239,
  "Louisville": 97,
  "Nebraska": 158,
  "Iowa State": 66,
  "Boise State": 68,
  "Oregon State": 204,
  "Pittsburgh": 221,
  "BYU": 252,
  "Duke": 150,
  "Wake Forest": 154,
  "UCF": 2116,
    "Liberty": 2335,
    "UTSA": 2636,
    "Miami": 2390,
    "Kansas": 2305,
    "Arizona State": 9,
    "Toledo": 2649,
    "UNLV": 2439,
    "SMU": 2567,
    "Arizona": 12,
    "Colorado": 38,
    "James Madison": 256,
    "Indiana": 84,
    "Army": 349,
    "Washington State": 265,
    "Memphis": 235,
    "Syracuse":183,
    "Texas State":326,
    "South Florida": 58,
    "Georgia Tech": 59,
    "Florida": 57,
    "Cincinnati": 2132,
    "Rutgers": 164,
    "Boston College": 103,
    "Virginia Tech": 259,
    "Fresno State": 278,
    "Jacksonville State": 55,
    "Houston": 248,
    "Ohio": 195,
    "North Texas": 249,
    "NC State": 152,
    "California": 25,
    "Florida Atlantic": 2226,
    "Old Dominion": 295,
    "Virginia": 258,
    "UConn": 41,
    "Vanderbilt": 238,
    "App State": 2026,
    "Michigan State": 127,
    "Louisiana Tech": 2348,
    "East Carolina": 151,
    "Temple": 218,
    "Colorado State": 36,
    "Miami (OH)": 193,
    "Louisiana": 309,
    "New Mexico State": 166,
    "Stanford": 24,
    "Central Michigan": 2117,
    "Rice": 242,
    "Coastal Carolina": 324,
    "Georgia Southern": 290,
    "Akron": 2006,
    "New Mexico": 167,
    "Western Michigan": 2711,
    "San Diego State": 21,
    "Nevada": 2440,
    "Marshall": 276,
    "Hawai'i": 62,
    "Air Force": 2005,
    "Sam Houston": 2534,
    "Eastern Michigan": 2199,
    "Georgia State": 2247,
    "UAB": 5,
    "Tulsa": 202,
    "Southern Miss": 2572,
    "Kennesaw State": 338,
    "Charlotte": 2429,
    "Ball State": 2050,
    "Delaware": 48,
    "Kent State": 2309,
    "Missouri State": 2623,
    "UL Monroe": 2433,
    "Middle Tennessee": 2393,
    "Massachusetts": 113,
    "San Jos\u00e9 State": 23,
    "San Jose State": 23,
    "West Virginia": 277,
    "Wyoming": 2751,
    "Arkansas State": 2032,
    "UTEP": 2638,
    "Utah State": 328,
    "Florida International": 2229,
    "Troy": 2653,
    "South Alabama": 6,
    "Navy": 2426,
    "Buffalo": 2084,
    "Western Kentucky": 98,
    "Northwestern": 77,
    "Northern Illinois": 2459,
    "Bowling Green": 189,
    "North Dakota State": 2449,
    "Sacramento State": 16,

};
